import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import "../../components/customer-information/customer-information.css";
import { useDispatch } from "react-redux";
import AddButton from "../../components/buttons/button";
import successToast from "../../components/helper-components/success-toast";
import CheckBox from "../../components/forms/check-box-field";
import errorToast from "../../components/helper-components/error-toast";
import { useNavigate } from "react-router-dom";
import LoginInputField from "../forms/login-input-field";
import LoginSelectField from "../forms/login-select-field";
import {
  RolesListAction,
  departmentListAction,
  storeListAction,
} from "../../redux/actions/general-action";
import {
  userCreateAction,
  userEditAction,
} from "../../redux/actions/user-action";
import { isAdmin } from "../../redux/config";
import SelectField from "../forms/select-field";

const UsersCreateViewEdit = ({ user = {}, disabled = false, page }) => {
  const dispatch = useDispatch();
  const [depList, setDepList] = useState([]);
  const [rolesList, setRolesList] = useState([]);
  const [storelist, setStorelist] = useState([]);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const initialValues = {
    ...(user?.user_id ? { user_id: user?.user_id } : {}),

    pos_id: user.pos_id || "", // new

    user_store_id: user.user_store_id || "ST2345",
    user_role: user.user_role || "",
    user_role_id: user.user_role_id || "", //new
    user_name: user.user_name || "",
    user_email: user.user_email || "",
    user_phone_number: user.user_phone_number || "",
    user_department: user.user_department || "",
    user_min_dis_per: user.user_min_dis_per || 0,
    user_max_dis_per: user.user_max_dis_per || 0,
    change_password_next_login: user.change_password_next_login || false,
    password_never_expires: user.password_never_expires || false,
  };

  if (page === "edit") {
    initialValues.update_password = false;
    initialValues.old_user_password = "";
    initialValues.new_user_password = "";
    initialValues.confirm_new_user_password = "";
  } else if (page === "create") {
    initialValues.user_password = "";
    initialValues.confirmPassword = "";
  }

  const validationSchema = Yup.object().shape({
    user_name: Yup.string().required("Username is required"),
    user_role: Yup.string().required("Role is required"),
    user_department: Yup.string(),
    user_phone_number: Yup.string()
      .matches(/^\d{10}$/, "Invalid phone number")
      .required("Mobile Number is required"),
    user_email: Yup.string().email("Invalid email address"),
    user_password:
  page === "create"
    ? Yup.string()
        .required("Password is required")
        .min(8, "Password must be at least 8 characters long")
      : Yup.string().min(8, "Password must be at least 8 characters long"),
    confirmPassword:
      page === "create"
        ? Yup.string()
            .oneOf([Yup.ref("user_password"), null], "Passwords must match")
            .required("Confirm Password is required")
        : Yup.string(),
  });
  const onSubmit = (values) => {
  setLoading(true);

  const payload = {
    ...values,
    user_max_dis_per:
      values.user_max_dis_per === "" ||
      values.user_max_dis_per === null ||
      values.user_max_dis_per === undefined
        ? 0
        : Number(values.user_max_dis_per),

    user_min_dis_per:
      values.user_min_dis_per === "" ||
      values.user_min_dis_per === null ||
      values.user_min_dis_per === undefined
        ? 0
        : Number(values.user_min_dis_per),
  };

  const name = payload.user_department;
  if (name) {
    const match = depList.find((item) => item.label === name);
    if (match) {
      payload.user_department_id = match.id;
    }
  }

  if (page === "create") {
    const { confirmPassword, ...formData } = payload;
    dispatch(userCreateAction(formData, onSuccess, onError));
  } else {
    const { confirm_new_user_password, update_password, ...formData } = payload;
    if (!update_password) {
      delete formData.old_user_password;
      delete formData.new_user_password;
    }
    dispatch(userEditAction(formData, onSuccess, onError));
  }
};

  const onSuccess = (data) => {
    setLoading(false);
    navigate("/user");
    successToast(data?.message);
  };
  const onError = (data) => {
    setLoading(false);
    errorToast(data?.data?.message);
  };

  useEffect(() => {
    dispatch(departmentListAction(onSuccessDep, onErrorDep));
    dispatch(RolesListAction(onSuccessRoles, onErrorRoles));
  }, []);
  const onSuccessDep = (data) => {
    setDepList(
      data?.data?.map((item) => ({
        label: item?.department_name,
        value: item?.department_name,
        id: item?.department_id,
      }))
    );
  };
  const onErrorDep = (data) => {};
  const onSuccessRoles = (data) => {
    setRolesList(
      data?.data?.map((item) => ({
        label: item?.role_name,
        value: item?.role_name,
        id: item?.role_id,
      }))
    );
  };
  const onErrorRoles = (data) => {};

  const onSuccessstore = (data) => {
    setStorelist(
      data?.data?.map((item) => ({
        label: item?.firm_name,
        value: item?.store_id,
      }))
    );
  };

  const onErrorstore = (data) => {};

  useEffect(() => {
    if (isAdmin) {
      dispatch(storeListAction(onSuccessstore, onErrorstore));
    }
  }, []);
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue }) => {
        return (
          <Form className="h-full flex flex-col  items-center">
            <div className="2xl:w-[25%] lg:w-[40%] p-5">
              <LoginInputField
                isDisabled={disabled}
                type="text"
                name="user_name"
                placeholder="Enter your username"
                label="Username"
                isRequired={true}
              />

              {isAdmin && (
                <LoginSelectField
                  isDisabled={disabled}
                  options={storelist}
                  name="pos_id"
                  placeholder={"Select Store"}
                  isRequired={true}
                  label={"Select Store"}
                />
              )}

              <LoginSelectField
                isDisabled={disabled}
                options={rolesList}
                name="user_role"
                placeholder={"Select role"}
                isRequired={true}
                label={"Role"}
                onChange={(selectedOption) => {
                  console.log("Selected option:", selectedOption);
                  setFieldValue("user_role_id", selectedOption?.id);
                  // Your custom logic here
                }}
              />
              <LoginSelectField
                isDisabled={disabled}
                options={depList}
                name="user_department"
                placeholder={"Select department"}
                isRequired={false}
                label={"Department"}
              />
              <LoginInputField
                isDisabled={disabled}
                type="number"
                name="user_phone_number"
                placeholder="Enter your Mobile Number"
                label="Mobile Number"
                isRequired={true}
              />
              <LoginInputField
                isDisabled={disabled}
                type="email"
                name="user_email"
                placeholder="Enter your email"
                label="Email"
                isRequired={false}
              />
              {page === "edit" && (
                <CheckBox conClass="mb-5" items={updatePass} />
              )}
              {page === "edit" && values?.update_password && (
                <>
                  <LoginInputField
                    type="password"
                    name="old_user_password"
                    placeholder="Enter your old password"
                    label="Old Password"
                    isRequired={true}
                    isPasswordEye={true}
                  />
                  <LoginInputField
                    type="password"
                    name="new_user_password"
                    placeholder="Enter your new password"
                    label="New Password"
                    isRequired={true}
                    isPasswordEye={true}
                  />
                  <LoginInputField
                    type="password"
                    name="confirm_new_user_password"
                    placeholder="Confirm your new password"
                    label="Confirm New Password"
                    isRequired={true}
                    isPasswordEye={true}
                  />
                </>
              )}
              {page === "create" && (
                <>
                  <LoginInputField
                    type="password"
                    name="user_password"
                    placeholder="Enter your password"
                    label="Password"
                    isRequired={true}
                    isPasswordEye={true}
                  />
                  <LoginInputField
                    type="password"
                    name="confirmPassword"
                    placeholder="Confirm your password"
                    label="Confirm Password"
                    isRequired={true}
                    isPasswordEye={true}
                  />
                </>
              )}
              <LoginInputField
                isDisabled={disabled}
                type="number"
                name="user_min_dis_per"
                placeholder="Min Dis %"
                label="Min Dis(%)"
                isRequired={false}
                onChange={(e) => {
                  let val = e.target.value;
                  if (val === "") {
                    setFieldValue("user_min_dis_per", "");
                    return;
                  }

                  let value = Math.min(Number(val), 100);

                  if (
                    values.user_max_dis_per > 0 &&
                    values.user_max_dis_per < value
                  ) {
                    value = values.user_max_dis_per;
                  }

                  setFieldValue("user_min_dis_per", value);
                }}
              />


              <LoginInputField
                isDisabled={disabled}
                type="number"
                name="user_max_dis_per"
                placeholder="Max Dis %"
                label="Max Dis(%)"
                isRequired={false}
                onChange={(e) => {
                  let value = Math.min(Number(e.target.value), 100);
                  if (
                    values.user_min_dis_per > 0 &&
                    values.user_min_dis_per > value
                  ) {
                    value = values.user_min_dis_per;
                  }
                  setFieldValue("user_max_dis_per", value);
                }}
              />
              <CheckBox
                isDisabled={disabled}
                conClass="flex flex-col gap-3 mb-5"
                items={items}
              />
              {page !== "view" && (
                <AddButton
                  loading={loading}
                  prefixIcon={false}
                  className="bg-primary text-white w-full py-2 rounded flex justify-center fw_500 text-sm "
                  type="submit"
                  text={`${page === "create" ? "Create User" : "Update User"}`}
                />
              )}
            </div>
            <div className="h-[100rem]"></div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default UsersCreateViewEdit;
const items = [
  {
    label: "Password Never Expires",
    name: "password_never_expires",
    isRequired: false,
  },
  {
    label: "Change Password at Next Login",
    name: "change_password_next_login",
    isRequired: false,
  },
];

const updatePass = [
  {
    label: "Update Password",
    name: "update_password",
    isRequired: false,
  },
];
